import viMessages from "@/app/locale/vi.json";
import enMessages from "@/app/locale/en.json";

export const locales = ["vi", "en"] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "vi";

export const messages = {
   vi: viMessages,
   en: enMessages
} as const;

export const i18nConfig = {
   defaultLocale,
   locales,
   localePrefix: "always",
   timeZone: "Asia/Saigon",
   localeDetection: true
} as const;

export type LanguagesMapping = {
   [key in string]: string;
};
export const LANGUAGES_MAPPING: LanguagesMapping = {
   en: "English",
   vi: "Vietnamese"
};
